import { Modal } from "antd";
import { SyntheticEvent, useCallback, useEffect, useMemo, useState } from "react";
import styled from "@emotion/styled";
import { getLanguage } from "auth-provider";
import "./customize.css";
import { LabelType } from "./page-header";
import dayjs from "dayjs";
import { IS_NOT_Undefined_Null } from "utils";
import { BirthdayContent } from "./contant";
const YEARS = 100;

export const BirthdayEntry = (props: {
    open: boolean;
    onConfirm: (birthday: dayjs.Dayjs) => void;
    onCancel: () => void;
}) => {
    const lang = getLanguage() as LabelType;

    const [year, setYear] = useState<number | null>(null);
    const [month, setMonth] = useState<number | null>(null);
    const [day, setDay] = useState<number | null>(null);
    const [birthday, setBirthday] = useState<dayjs.Dayjs | null>(null);
    const yearOptions = useMemo(() => {
        let options: {
            display: string;
            value: number;
        }[] = [];
        for (var i = 0; i <= YEARS; i++) {
            let a = dayjs().subtract(i, 'year');
            options.push({
                display: a.format('YYYY'),
                value: a.year(),
            });
        }

        return options;

    }, []);

    const monthOptions = useMemo(() => {
        let options: {
            display: string;
            value: number;
        }[] = [];

        if (!IS_NOT_Undefined_Null(year)) {
            return [];
        }

        for (var i = 1; i <= 12; i++) {
            options.push({
                display: i < 10 ? `0${i}` : `${i}`,
                value: i,
            });
        }

        return options;

    }, [year]);

    const daysOptions = useMemo(() => {
        let options: {
            display: string;
            value: number;
        }[] = [];
        if (!IS_NOT_Undefined_Null(year) || !IS_NOT_Undefined_Null(month)) {
            return [];
        }
        let days = dayjs(`${year}-${(month as number) < 10 ? ('0' + month) : month}`, "YYYY-MM").daysInMonth();
        for (var i = 1; i <= days; i++) {
            options.push({
                display: i < 10 ? `0${i}` : `${i}`,
                value: i,
            });
        }
        return options;

    }, [year, month]);


    const onYearChanged = useCallback((event: SyntheticEvent) => {
        let selectedOptionValue = (event.target as HTMLSelectElement).selectedOptions[0].value;
        if (selectedOptionValue !== '') {
            setYear(Number.parseInt(selectedOptionValue, 10));
        } else {
            setYear(null);
        }

    }, []);

    const onMonthChanged = useCallback((event: SyntheticEvent) => {
        let selectedOptionValue = (event.target as HTMLSelectElement).selectedOptions[0].value;
        if (selectedOptionValue !== '') {
            setMonth(Number.parseInt(selectedOptionValue, 10));
        } else {
            setMonth(null);
        }

    }, []);

    const onDayChanged = useCallback((event: SyntheticEvent) => {
        let selectedOptionValue = (event.target as HTMLSelectElement).selectedOptions[0].value;
        if (selectedOptionValue !== '') {
            setDay(Number.parseInt(selectedOptionValue, 10));
        } else {
            setDay(null);
        }
    }, []);

    useEffect(() => {
        if (year && month && day && IS_NOT_Undefined_Null(year) && IS_NOT_Undefined_Null(month) && IS_NOT_Undefined_Null(day)) {
            let birthdayStr = `${(month as number) < 10 ? ('0' + month) : month}/${(day as number) < 10 ? ('0' + day) : day}/${year}`;
            let birthday = dayjs(birthdayStr, 'MM/DD/YYYY');
            setBirthday(birthday);
        } else {
            setBirthday(null);
        }
    }, [year, month, day]);


    const _onConfirm_ = useCallback(() => {
        if (birthday) {
            props.onConfirm(birthday);
        }
    }, [props, birthday]);

    const _onCancel_ = useCallback(() => {
        props.onCancel();
    }, [props,]);


    return (
        <>
            <Modal
                title={null}
                closable={false}
                open={!!props.open}
                footer={null}
                bodyStyle={{ color: "red" }}
                className={"cur-model birthday"}
            >
                <Header>{BirthdayContent.title[lang]}</Header>
                <SelectorGroups>
                    <select name="year" className="select" onChange={onYearChanged} style={{ flex: 1 }}>
                        <option value='' >{BirthdayContent.please_select_year[lang]}</option>
                        {
                            yearOptions.map(({ display, value }) => {
                                return <option key={value} value={value}>{display}</option>
                            })
                        }
                    </select>

                    <select name="month" className="select" onChange={onMonthChanged} style={{ flex: 1, marginLeft: '1rem' }}>
                        <option value=''>{BirthdayContent.please_select_month[lang]}</option>
                        {
                            monthOptions.map(({ display, value }) => {
                                return <option key={value} value={value}>{display}</option>
                            })
                        }
                    </select>
                    <select name="day" className="select" onChange={onDayChanged} style={{ flex: 1, marginLeft: '1rem' }}>
                        <option value=''>{BirthdayContent.please_select_day[lang]}</option>
                        {
                            daysOptions.map(({ display, value }) => {
                                return <option key={value} value={value}>{display}</option>
                            })
                        }
                    </select>
                </SelectorGroups>
                <Header>
                    <ConfirmButton isDisabled={!!!birthday} lang={lang} onClick={_onConfirm_}>{BirthdayContent.confirm_button[lang]}</ConfirmButton>
                    <CancelButton lang={lang} style={{ marginLeft: '10px' }} onClick={_onCancel_}>{BirthdayContent.cancel_button[lang]}</CancelButton>
                </Header>
            </Modal>
        </>
    );
};

const SelectorGroups = styled.div`
width:100%;
display:flex;

margin: 3rem auto;
`;

const Header = styled.div`
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #1D1B2E;
    
`;
const ConfirmButton = styled.button<{
    isDisabled: Boolean;
    lang: LabelType;
}>`
    background: ${(props) => (props.isDisabled ? "#C0C2CC" : "#ed2668")};
    font-weight: ${(props) => (props.lang === "en" ? 700 : 600)};
    font-size: 1.8rem;
    border-radius: 2.2rem;
    height: 4.4rem;
    line-height: 1;
    border: none;
    color: #fff;
    width: 100%;
  `;

const CancelButton = styled.button<{
    lang: LabelType;
}>`
    font-weight: ${(props) => (props.lang === "en" ? 700 : 600)};
    font-size: 1.8rem;
    border-radius: 2.2rem;
    height: 4.4rem;
    line-height: 1;
    border: none;
    background-color: #F5F5F5;
    color:#636371;
    width: 100%;
  `;
